import { i18n as _i18n } from "@lingui/core";
import React from 'react';
import { useLingui } from '@lingui/react';
import { BannerReturnCustomer, CarleadLayout } from '@wkda/carlead-creation-components';
import { Helmet } from 'react-helmet';
import { CarleadCollapseButtonFaq, CarleadHowItWorks, CarleadTextButton, CarleadWhyChoose } from '../../../../components';
import { CarleadCrossPromoBannerAH } from '../../../../components/carlead/CarleadCrossPromoBannerAH';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CarleadHIWWhyChooseWkdaFaq = ({
  form,
  howItWorksShowCta = false,
  showCrossPromoBanner = true
}) => {
  const {
    i18n
  } = useLingui();
  return /*#__PURE__*/_jsxs(CarleadLayout, {
    customBanner: BannerReturnCustomer,
    containerClassName: "carlead-redesign",
    modernLayout: true,
    children: [/*#__PURE__*/_jsx(Helmet, {
      children: /*#__PURE__*/_jsx("title", {
        children: i18n._('carlead.pageTitle')
      })
    }), /*#__PURE__*/_jsxs("div", {
      "data-category": "Lead Page",
      children: [form, /*#__PURE__*/_jsx(CarleadHowItWorks, {
        showCTA: howItWorksShowCta
      }), /*#__PURE__*/_jsx(CarleadWhyChoose, {}), /*#__PURE__*/_jsx(CarleadCollapseButtonFaq, {}), /*#__PURE__*/_jsx(CarleadTextButton, {
        text: _i18n._(
        /*i18n*/
        {
          id: 'carlead.textButton.text'
        })
      }), showCrossPromoBanner && /*#__PURE__*/_jsx(CarleadCrossPromoBannerAH, {})]
    })]
  });
};
export default CarleadHIWWhyChooseWkdaFaq;